import * as React from 'react';
import './index.css';
import Datafeed from './api/'

/*function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}*/
	
export class TVChartContainer extends React.PureComponent {

	static defaultProps = {
		symbol: 'Exhcnage:BTC/USD',
		interval: '60',
		containerId: 'tv_chart_container',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		timezone:'Australia/Sydney',
		autosize: true,
		studiesOverrides: {},
		favorites:["1", "5", "15", "30", "60", "120", "240", "1D"],
		disabled_features: ["header_undo_redo","header_compare","header_symbol_search","header_chart_type","display_market_status","chart_property_page_background","timeframes_toolbar","header_screenshot","header_interval_dialog_button","symbol_info","header_saveload"],
	};

	componentDidMount() {
		var symbol = window.location.href.split(/[_/]/)
		var css_url = '';
		var override = '';	
		var weburl  = window.location.origin;
		if(symbol[6] === 'light'){
			css_url = weburl+'/coininfo-light.css';
			override = {
				"mainSeriesProperties.showCountdown": true,
				"paneProperties.background": "#ffffff",
				"paneProperties.vertGridProperties.color": "#ddd",
				"paneProperties.horzGridProperties.color": "#ddd",
				"symbolWatermarkProperties.transparency": 90,
				"scalesProperties.textColor" : "#AAA",
				"scalesProperties.lineColor" : "rgba(60, 69, 93, 0.3)",
				"mainSeriesProperties.candleStyle.wickUpColor": '#336854',
				"mainSeriesProperties.candleStyle.wickDownColor": '#7f323f',
			};
		}else if(symbol[6] === 'dark'){
			css_url = weburl+'/coininfo-dark.css';
			override = {
				"mainSeriesProperties.showCountdown": true,
				"paneProperties.background": "#191f2b",
				"paneProperties.vertGridProperties.color": "#363c4e",
				"paneProperties.horzGridProperties.color": "#363c4e",
				"symbolWatermarkProperties.transparency": 90,	
				"scalesProperties.textColor" : "#AAA",
				"mainSeriesProperties.candleStyle.wickUpColor": '#336854',
				"mainSeriesProperties.candleStyle.wickDownColor": '#7f323f',
			};
		}else{
			css_url = weburl+'/exchange.css';
			override = {
				"mainSeriesProperties.showCountdown": true,	
				"paneProperties.background": "#191f2b",
				"paneProperties.vertGridProperties.color": "#363c4e",
				"paneProperties.horzGridProperties.color": "#363c4e",
				"symbolWatermarkProperties.transparency": 90,
				"scalesProperties.textColor" : "#748594",
				"mainSeriesProperties.candleStyle.wickUpColor": '#336854',
				"mainSeriesProperties.candleStyle.wickDownColor": '#7f323f',	
			};
		}
		const widgetOptions = {
			debug: false,
			symbol: 'BCH',
			datafeed: Datafeed,	
			interval: this.props.interval,
			container_id: this.props.containerId,
			library_path: this.props.libraryPath,	
			locale: symbol[7],
			client_id: this.props.clientId,
			user_id: this.props.userId,
			timezone:'Australia/Sydney',
			fullscreen: true,
			autosize: this.props.autosize,	
			studies_overrides: this.props.studiesOverrides,
			custom_css_url:css_url,	
			overrides: override,
			time_frames: [
				{ text: "1m", resolution: "1" },
				{ text: "5m", resolution: "5" },
				{ text: "15m", resolution: "15" },
				{ text: "30m", resolution: "30" },
			],
			favorites:{
				intervals:["1", "5","15","30","60","240","1D" /*"30", "60", "120", "240", "1D" */]
				//chartTypes:["Area", "Candles"]
			},
			//numeric_formatting: { decimal_sign: "," },
			//enabled_features: ["caption_buttons_text_if_possible"],
			//customFormatters: {
				/* timeFormatter: {
				  format: function(date) { var _format_str = '%h:%m'; return _format_str.replace('%h', date.getUTCHours(), 2). replace('%m', date.getUTCMinutes(), 2). replace('%s', date.getUTCSeconds(), 2); }
				}, */
				/*dateFormatter: {
				  	format: function(date) {
					  	var month = 0;
					  	var day = 0;
						month 	= "" + (date.getUTCMonth() + 1); if (month.length === 1) { month = "0" + month; }
						day 	= "" + date.getUTCDate(); if (day.length === 1) { day = "0" + day; }
						return day + '-' + month + '-' + date.getUTCFullYear(); 
					}
				}
			},*/
			//disabled_features: [/* "left_toolbar", "header_undo_redo",*/ "header_compare",/* "header_symbol_search", "header_chart_type",*/"display_market_status","chart_property_page_background",/* "timeframes_toolbar", "header_screenshot", */"header_interval_dialog_button",/* "symbol_info", */"header_saveload","use_localstorage_for_settings","volume_force_overlay"],
			disabled_features: [/* "left_toolbar", "header_undo_redo",*/ "header_compare",/* "header_symbol_search", "header_chart_type",*/"display_market_status","chart_property_page_background",/* "timeframes_toolbar", "header_screenshot", */"header_interval_dialog_button",/* "symbol_info", */"header_saveload"/* ,"use_localstorage_for_settings","volume_force_overlay" */, "volume_force_overlay"],
		};	

		
		const widget = (window.tvWidget = new window.TradingView.widget(
			widgetOptions
		));
  
		widget.onChartReady(() => {
			console.log("Chart has loaded!");
			//window.localStorage.clear();
		});
	}

	render() {
		return (
			<div
				id={ this.props.containerId }
				className={ 'TVChartContainer' }
			/>
		);
	}	
}



// WEBPACK FOOTER //
// src/components/TVChartContainer/index.jsx